import { onScopeDispose, ref } from "vue";

export const TOOLTIP_DELAY = 700;

/**
 * The one tooltip the `v-tooltip` directive shows at a time, drawn by TooltipHost: the text and
 * where its element sits (centre, and the edges to place it below or, near the bottom, above).
 */
export interface FloatingTip {
  id: string;
  text: string;
  x: number;
  below: number;
  above: number;
}
export const floatingTip = ref<FloatingTip | null>(null);
let dismissCurrent: (() => void) | undefined;

/** Interaction cancels the pending hint until a new hover or keyboard focus. */
export function useDelayedTooltip(delay = TOOLTIP_DELAY) {
  const visible = ref(false);
  let timer: ReturnType<typeof setTimeout> | undefined;
  let dismissed = false;
  function hide() {
    clearTimeout(timer);
    timer = undefined;
    visible.value = false;
    if (dismissCurrent === cancel) dismissCurrent = undefined;
  }
  function cancel() {
    dismissed = true;
    hide();
  }
  function schedule() {
    hide();
    if (dismissed) return;
    dismissCurrent?.();
    dismissCurrent = cancel;
    timer = setTimeout(() => {
      if (!dismissed) visible.value = true;
    }, delay);
  }
  function enter() {
    dismissed = false;
    schedule();
  }
  function leave() {
    hide();
    dismissed = false;
  }
  onScopeDispose(hide);
  return { visible, enter, schedule, cancel, leave };
}
